import sensorsTrackJM from './index';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY } from '@/constants';
import slsLogger, { EVENT_TYPE } from '@/utils/slsLogger';

const STATISTIC_ACTION_MAP = [
  { key: 'COPY', action: EVENT_TYPE.COPY },
  { key: 'EXPORT', action: EVENT_TYPE.EXPORT },
  { key: 'DOWNLOAD', action: EVENT_TYPE.DOWNLOAD },
  { key: 'SHARE', action: EVENT_TYPE.CLICK },
  { key: 'SEND', action: EVENT_TYPE.ENTER },
  { key: 'SEARCH', action: EVENT_TYPE.SEARCH },
  { key: 'SWITCH', action: EVENT_TYPE.TAB_SWITCH },
  { key: 'TAB', action: EVENT_TYPE.TAB_SWITCH },
  { key: 'FILTER', action: EVENT_TYPE.FILTER },
  { key: 'SORT', action: EVENT_TYPE.SORT },
  { key: 'VIEW', action: EVENT_TYPE.NAVIGATE }
];

/**
 * 根据统计编号粗略归类行为类型，保证 SLS 中可以按操作语义过滤。
 * @param {string} statisticnum TRACK_MODULE_BRM 中的路径
 * @returns {string} slsLogger 行为类型
 */
function resolveBehaviorAction(statisticnum) {
  const upperStatisticnum = String(statisticnum || '').toUpperCase();
  const matched = STATISTIC_ACTION_MAP.find((item) => upperStatisticnum.includes(item.key));
  return matched?.action || EVENT_TYPE.CLICK;
}

/**
 * AI 进宝（AI_CHAT）埋点：与业务约定字段一致，便于分析。
 * @param {string} statisticnum TRACK_MODULE_BRM 中的路径，如 AI_CHAT.child.HOME.child.SEND_MESSAGE
 * @param {Record<string, unknown>} [extra] 附加业务字段
 */
export function trackAiChatBRM(statisticnum, extra = {}) {
  const jmUserInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);
  const content = {
    clickTime: new Date().toISOString(),
    userId: jmUserInfo?.uid || '',
    orgId: jmUserInfo?.organizationId || jmUserInfo?.orgId || '',
    ...extra
  };

  try {
    slsLogger.behavior({
      action: resolveBehaviorAction(statisticnum),
      target: {
        statisticnum,
        ...content
      }
    });
  } catch (error) {
    console.warn('[trackAiChatBRM] sls behavior failed:', error);
  }

  return sensorsTrackJM({
    statisticnum,
    content: JSON.stringify(content)
  });
}
